module.exports = __webpack_public_path__ + "static/img/reference_scale_male.822dac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reference_scale_male.png
// module id = W6BD
// module chunks = 1